const isProd = process.env.NODE_ENV === 'production';
const isNotLocalhost = window.location.hostname !== 'localhost';
const isNotPreview = !window.location.hostname.endsWith('.pages.dev');

export const shouldInitSentry = isProd && isNotLocalhost && isNotPreview;
